import { BaseFiltroInputDto } from "./base-filtro.input.dto";

export class ListarComunicadosInputDto extends BaseFiltroInputDto {
  public TextoPesquisa?: string;

  constructor(pesquisa: string, pagina: number, quantidade: number) {
    super(pagina, quantidade);
    this.TextoPesquisa = pesquisa;
  }
}
